import React from "react";
import Obrazek from "../../public/publicita.jpg"

const Projekty = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center">
      <div className="max-w-3xl mx-auto w-full py-8 px-4">
        <h1 className="text-4xl font-bold text-center mb-8 text-black pt-20">Projekty</h1>

        <div className="bg-white rounded-lg p-6 mb-8 shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-black">
            Škola se účastní dotačního programu OP JAK II
          </h2>

          {/* Image section */}
          <div className="mb-6 flex justify-center">
            <img src="/publicita.jpg" alt="Projekt OP JAK II" />
          </div>

          <div id="pouceni" className="mb-4 text-gray-700"></div>
        </div>
      </div>
    </div>
  );
};

export default Projekty;
